module.exports = __webpack_public_path__ + "img/shippingIndustrySolution_EN.jpg";